module.exports = __webpack_public_path__ + "static/Kucoin-0190ee07064c9d9ae43ce628bad0b7b1.png";